import React from "react";
import { Text } from "@fluentui/react-components";
import ResultCard from "./ResultCard";

const ResultList = ({ items, onSelect, className }) => {
  if (items.length === 0) return null;

  return (
    <div className={className}>
      <Text size={300} weight="regular" block>
        Search results
      </Text>
      {items.map((item) => (
        <ResultCard
          key={`${item.uid}-${item.entityId}`}
          item={item}
          checked={false}
          onChange={() => onSelect(item)}
        />
      ))}
    </div>
  );
};

export default ResultList;
